import { apiClient } from "./ApiConfig"

export const CartApi = {
    addItem: (body: any) => {
        return apiClient.post('/cart/add', body)
    },
    getItems: () => {
        return apiClient.get('/cart/items')
    },
    removeItem: (body: any) => {
        return apiClient.post('/cart/delete', body)
    },
    updateItem: (body: any) => {
        return apiClient.post('/cart/update', body)
    }
}

